import { render } from "./GeneralPolicyReport.vue?vue&type=template&id=2188cee2"
import script from "./GeneralPolicyReport.vue?vue&type=script&lang=js"
export * from "./GeneralPolicyReport.vue?vue&type=script&lang=js"

import "./GeneralPolicyReport.vue?vue&type=style&index=0&id=2188cee2&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__